import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const CHANGE_USER_SELECTION = NS + 'CHANGE_USER_SELECTION'

export const GET_STATE_ANALYTICS_REQUEST = NS + 'GET_STATE_ANALYTICS_REQUEST'
export const GET_STATE_ANALYTICS_SUCCESS = NS + 'GET_STATE_ANALYTICS_SUCCESS'
export const GET_STATE_ANALYTICS_ERROR = NS + 'GET_STATE_ANALYTICS_ERROR'

export const GET_STATE_LAST_CHANGED_REQUEST = NS + 'GET_STATE_LAST_CHANGED_REQUEST'
export const GET_STATE_LAST_CHANGED_SUCCESS = NS + 'GET_STATE_LAST_CHANGED_SUCCESS'
export const GET_STATE_LAST_CHANGED_ERROR = NS + 'GET_STATE_LAST_CHANGED_ERROR'

export const GET_TASK_BY_DUE_DATE_REQUEST = NS + 'GET_TASK_BY_DUE_DATE_REQUEST'
export const GET_TASK_BY_DUE_DATE_SUCCESS = NS + 'GET_TASK_BY_DUE_DATE_SUCCESS'
export const GET_TASK_BY_DUE_DATE_ERROR = NS + 'GET_TASK_BY_DUE_DATE_ERROR'

export const FIND_TASK_BY_WEEK_DIFF_DATE_REQUEST = NS + 'FIND_TASK_BY_WEEK_DIFF_DATE_REQUEST'
export const FIND_TASK_BY_WEEK_DIFF_DATE_SUCCESS = NS + 'FIND_TASK_BY_WEEK_DIFF_DATE_SUCCESS'
export const FIND_TASK_BY_WEEK_DIFF_DATE_ERROR = NS + 'FIND_TASK_BY_WEEK_DIFF_DATE_ERROR'

export const CHANGE_TASK_TABLE_SETTINGS = NS + 'CHANGE_TASK_TABLE_SETTINGS'
export const CHANGE_STATE_TABLE_SETTINGS = NS + 'CHANGE_STATE_TABLE_SETTINGS'

export const FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_REQUEST = NS + 'FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_REQUEST'
export const FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_SUCCESS = NS + 'FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_SUCCESS'
export const FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_ERROR = NS + 'FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_ERROR'



// WEBPACK FOOTER //
// ./src/modules/analytics/state/state-responsible/type.js